import { toast } from "react-toastify";
import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { IEmpresa, newEmpresa } from "../../model";

export class _SpedLancamentoStore {
  obs = observable({
    selectedEmpresa: newEmpresa() as IEmpresa,
    open_select_empresa: false as boolean,

    isEmpresa: false as boolean,

    lancamentos: [] as any[],
    lancamentos_length: 0 as number,
    lancamentos_filter: "" as string,
    lancamentos_current: 1 as number,
  })

  async handleBuscaLancamentos(cnpj: string, page: number, text: string) {

    let params = {
      cnpj: cnpj,
      page: page,
      limit: 10,
      text: text
    }
    try {
      let resp = await apiOperacao("sped").post('/sped/lancamentos/index', params)

      this.obs.lancamentos_length = 0
      this.obs.lancamentos = []

      if (resp.data.itens.length > 0) {
        this.obs.lancamentos = resp.data.itens
        this.obs.lancamentos_length = resp.data.count
      }

    } catch (ex) { }

  }

  async handleCreateLancamentos(params: any) {

    try {

      let resp = await apiOperacao("sped").post('/sped/lancamentos/create', params)

      if (resp.data.ok == true) {

        toast.success('Lançamento criado com sucesso.', {});

        this.obs.lancamentos_current = 1
        await this.handleBuscaLancamentos(this.obs.selectedEmpresa.cnpj, 1, this.obs.lancamentos_filter)

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

  async handleUpdateLancamentos(params: any) {

    try {

      let resp = await apiOperacao("sped").post('/sped/lancamentos/update', params)

      if (resp.data.ok == true) {

        toast.success('Lançamento atualizado com sucesso.', {});

        this.obs.lancamentos_current = 1
        await this.handleBuscaLancamentos(this.obs.selectedEmpresa.cnpj, 1, this.obs.lancamentos_filter)

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

  async handleDeleteLancamento(id: string) {

    try {

      let resp = await apiOperacao("sped").delete(`/sped/lancamentos/${id}`)

      if (resp.data.ok == true) {

        toast.success('Lançamento deletado com sucesso.', {});

        this.obs.lancamentos_current = 1
        await this.handleBuscaLancamentos(this.obs.selectedEmpresa.cnpj, 1, this.obs.lancamentos_filter)

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }


}

export const SpedLancamentoStore = new _SpedLancamentoStore();